import {
  AnimationTimings,
  getAnimationMultiplier,
  getAnimationTimings,
} from "@mono/constants"

// A client only ever renders one game at a time, so the game on screen can be
// parked here instead of threaded through every pure animation helper that has
// no other use for it. The server cannot do this — it runs many games at once,
// each possibly at a different speed — and calls getAnimationTimings(game)
// directly.
//
// Kept in sync from App.tsx whenever myGame changes. Anything the server waits
// on must read its duration from here, or a quick game's server will move on
// while the client is still mid-animation.
let activeGame: { settings?: { isQuickGame?: boolean } } | null = null

export const setActiveGameForAnimations = (
  game?: { settings?: { isQuickGame?: boolean } } | null
) => {
  activeGame = game ?? null
}

export const activeTimings = (): AnimationTimings => getAnimationTimings(activeGame)

export const activeMultiplier = (): number => getAnimationMultiplier(activeGame)
